import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import ServiceCard from "@/components/ServiceCard";
import { useLang } from "@/contexts/LanguageContext";
import { SERVICES, SITE } from "@/data/site";

const Services = () => {
  const { t } = useLang();

  return (
    <div data-testid="page-services">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pt-16 sm:pt-24 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <span className="text-[11px] uppercase tracking-[0.22em] text-[#082133] font-semibold">
              {t("services.eyebrow")}
            </span>
            <h1 className="mt-4 font-display font-semibold text-[#111111] text-[40px] sm:text-[54px] lg:text-[64px] leading-[1.05] tracking-[-0.03em]">
              {t("services.title")}
            </h1>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[17px] leading-relaxed text-[#4B5563]">
              {t("services.lead")}
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-6">
          <ServiceCard service={SERVICES[0]} span="md:col-span-3 lg:col-span-7" />
          <ServiceCard service={SERVICES[1]} span="md:col-span-3 lg:col-span-5" />
          <ServiceCard service={SERVICES[2]} span="md:col-span-2 lg:col-span-4" />
          <ServiceCard service={SERVICES[3]} span="md:col-span-2 lg:col-span-4" />
          <ServiceCard service={SERVICES[4]} span="md:col-span-2 lg:col-span-4" />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pb-24">
        <div className="rounded-[32px] bg-[#082133] text-[#FAFAFA] px-8 sm:px-12 py-14 sm:py-20 relative overflow-hidden grain">
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <h3 className="font-display font-semibold text-[30px] sm:text-[42px] leading-[1.1] tracking-[-0.02em]">
                {t("home.ctaBlockTitle")}
              </h3>
              <p className="mt-4 max-w-xl text-[#FAFAFA]/75 text-[16px] leading-relaxed">
                {t("home.ctaBlockLead")}
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Link to="/contact" className="block">
                <Button
                  data-testid="services-cta-book"
                  className="w-full rounded-full h-14 bg-[#FAFAFA] text-[#082133] hover:bg-white text-[15px] font-medium tracking-wide"
                >
                  {t("common.bookOnline")}
                  <ArrowUpRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <a
                href={SITE.phoneHref}
                data-testid="services-cta-call"
                className="inline-flex items-center justify-center gap-2 rounded-full h-14 px-6 border border-[#FAFAFA]/25 text-[#FAFAFA] hover:bg-[#FAFAFA]/10 text-[15px] font-medium"
              >
                <Phone className="h-4 w-4" />
                {SITE.phone}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
